import React from 'react'
import "../styles/loader.scss"
const Loader = () => {
  return (
    <>
<div class="loader_parent">
          <div class="loader"></div>
</div>
    </>
  )
}

export default Loader
